import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$: Observable<boolean> = this.loadingSubject.asObservable();
  
  private loadingMessage = new BehaviorSubject<string>('Cargando...');
  loadingMessage$: Observable<string> = this.loadingMessage.asObservable();

  // Contador para manejar múltiples peticiones
  private loadingCount = 0;

  constructor() {}

  /**
   * Muestra el indicador de carga con un mensaje personalizado
   */
  start(message: string = 'Cargando...'): void {
    this.loadingCount++;
    this.loadingMessage.next(message);
    this.loadingSubject.next(true);
  }

  /**
   * Oculta el indicador de carga
   */
  stop(): void {
    this.loadingCount--;
    
    if (this.loadingCount <= 0) {
      this.loadingCount = 0;
      this.loadingSubject.next(false);
    }
  }

  /**
   * Establece un nuevo mensaje de carga
   */
  setMessage(message: string): void {
    this.loadingMessage.next(message);
  }

  /**
   * Detiene todos los procesos de carga forzosamente
   */
  stopAll(): void {
    this.loadingCount = 0;
    this.loadingSubject.next(false);
  }
}
